import LocationProps from "../../types/Location";

class MapUtils {
    getLocationData(locationId: string) {
        return $.ajax({
            url: "./GetStore/?id=" + locationId,
            method: "GET",
            error: (error) => console.log(error),
            success: (data) => data,
        });
    }

    boldenPartsOfText(text: string, search: string): string {
        const terms = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
        if (!terms.length) return text;

        const regex = new RegExp(`(${terms.join("|")})`, "gi");
        return text.replace(regex, "<strong>$1</strong>");
    }

    isValidCoords(coords: { lat: number; lng: number } | undefined) {
        return (
            coords &&
            coords.lat !== 0 &&
            coords.lat < 90 &&
            coords.lat > -90 &&
            coords.lng !== 0 &&
            coords.lng < 180 &&
            coords.lng > -180
        );
    }

    toTitleCase(str: string) {
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    }

    getCoordinatesOfLocation(location: LocationProps) {
        return {
            lat: this.trimCoordinate(location.Lat || ""),
            lng: this.trimCoordinate(location.Lon || ""),
        };
    }

    trimCoordinate(coordinate: string | number | undefined) {
        return parseFloat(Number(coordinate).toFixed(6));
    }

    euclidean(
        point1: { lat: number; lng: number },
        point2: { lat: number; lng: number },
    ) {
        return (
            Math.pow(point1.lat - point2.lat, 2) +
            Math.pow(point1.lng - point2.lng, 2)
        );
    }
}

export default MapUtils;
